import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Statistic from "./Statistic";
import Wallet from "./Wallet";

const Dashboard = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="pages-dashboard">
        <div className="title">{t("dashboard.dashboard")}</div>
        <Statistic />
        <Wallet />
      </div>
    </>
  );
};

export default Dashboard;
